/** SERP-optimerade titlar för produkter med GSC-fynd (slug → title). */
const PRODUCT_SEO_TITLES: Record<string, string> = {
  'lilla-studentflaket':
    'Lilla studentflaket – ljudpaket (se studentflak pris) | festutrustning.se',
  'tross-2-meter':
    'Hyra tross 2 meter Skåne – event & scen | festutrustning.se',
  'tross-0-5-m':
    'Tross 0,5 m – kort sektion (se även 2 m) | festutrustning.se',
  'trevags-tross':
    'Trevägs-tross – koppel till trossystem | festutrustning.se',
  'scenpodie-1x0-5-m':
    'Hyra scenpodie 1×0,5 m Skåne | festutrustning.se',
  'scenpodie-2x1-m':
    'Scenpodie 2×1 m – större podium | festutrustning.se',
  'pioneer-xdj-rx3-all-in-one-dj-system-i-absolut-toppklass':
    'Hyra Pioneer XDJ-RX3 Skåne – all-in-one DJ | festutrustning.se',
  projektor:
    'Hyra projektor 5000 lumen Skåne – event & film | festutrustning.se',
};

export function getProductSeoTitle(
  slug: string | undefined,
  fallback: string,
): string {
  if (slug && PRODUCT_SEO_TITLES[slug]) {
    return PRODUCT_SEO_TITLES[slug];
  }
  return fallback;
}
